module.exports = __webpack_public_path__ + "static/media/van.563ce5b2.svg";